import script from "./MakerCartGuide8Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide8Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide8Page.vue?vue&type=style&index=0&id=59cc0b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59cc0b06"]])

export default __exports__